import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { ListImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/listImpression.trackingInfo";
import { toChunks } from "@omni/utils/array.utils";

import * as AlgoliaUserService from "@/services/algolia/algoliaUser.service";

import {
    AlgoliaAnalyticsEventNames,
    AlgoliaAnalyticsEvents
} from "../AlgoliaAnalyticsEvents";
import {
    AlgoliaAnalyticsMinimumDataset,
    AlgoliaViewPayload
} from "../AlgoliaAnalyticsMinimumDataset";

export interface AlgoliaAnalyticsProductListImpression
    extends AlgoliaAnalyticsMinimumDataset<AlgoliaViewPayload> {}

const getAlgoliaProductViewedPayload = (
    eventData: ListImpressionTrackingInfo,
    objectIDs: Array<string>
): AlgoliaViewPayload => {
    return {
        authenticatedUserToken: AlgoliaUserService.getAuthenticatedUserToken(),
        eventName: AlgoliaAnalyticsEventNames.HitsViewed,
        index: eventData.meta.index,
        userToken: AlgoliaUserService.getUserToken(),
        objectIDs
    };
};

const getAlgoliaAnalyticsProductListmpression = (
    data: TypedAnalyticsEvent<ListImpressionTrackingInfo>
): Array<AlgoliaAnalyticsProductListImpression> => {
    const chunks = toChunks(data.payload.eventData.ids, 20);
    return chunks.map((chunk) => ({
        eventName: AlgoliaAnalyticsEvents.ViewedObjectIDs,
        payload: getAlgoliaProductViewedPayload(data.payload.eventData, chunk)
    }));
};

export { getAlgoliaAnalyticsProductListmpression };
